export const solutionsEn = {
  solutionsPages: {
    common: {
      requestDemo: "Request Demo",
      talkToSales: "Talk to Sales",
      backToSolutions: "← Back to Solutions",
      keyFeatures: "Key Features",
      whatYouGet: "What You Get",
      howItWorks: "How It Works",
      readyToStart: "Ready to get started?",
      contactUs: "Contact us",
    },
    index: {
      title: "Solutions for cooperatives, insurers and large operations",
      subtitle: "One auditable dataset per parcel — wired into the workflows your team already runs.",
      learnMore: "Learn More",
    },
    insurance: {
      badge: "For Insurance Companies",
      title: "Field monitoring & evidence for parametric insurance",
      subtitle: "Continuous Sentinel-2 monitoring of every insured parcel, with auditable NDVI / NDWI / ET₀ history and SHA-256 + Polygon anchoring. Built for underwriting, claims and reinsurance reporting.",
      cardTitle: "Insurance Companies",
      cardDesc: "Auditable NDVI, ET₀ and risk data for parametric products and faster, evidence-based claims.",
      features: {
        monitoring: {
          title: "Continuous parcel monitoring",
          desc: "NDVI, NDWI, EVI and NDRE updated every 5 days from Sentinel-2, with cloud-masked time series for every insured parcel.",
        },
        triggers: {
          title: "Configurable parametric triggers",
          desc: "Drought (NDVI / NDWI), frost, heat stress and fire exposure thresholds defined per crop and region.",
        },
        audit: {
          title: "Auditable evidence trail",
          desc: "Every index value is hashed (SHA-256) and anchored on Polygon, producing court-ready evidence with zero manual editing.",
        },
        api: {
          title: "REST API + webhooks",
          desc: "Push parcel-level indices and alerts directly into your claims management system. Documented OpenAPI spec.",
        },
        risk: {
          title: "Risk scoring per parcel",
          desc: "Composite Sentinel Score (0–100) and historical anomaly detection for portfolio underwriting.",
        },
        reports: {
          title: "Claim-ready PDF reports",
          desc: "One-click loss-event reports with satellite imagery, indices, weather context and blockchain proof.",
        },
      },
    },
    cooperatives: {
      badge: "For Cooperatives",
      title: "Multi-member operations, one shared cockpit",
      subtitle: "Aggregate every member's parcels into a single dashboard. Anonymous benchmarking, CAP / eco-scheme reporting and shared advisory tools — without giving up data sovereignty.",
      cardTitle: "Cooperatives",
      cardDesc: "Multi-member portfolio dashboard, anonymous benchmarking and 1-click CAP & eco-scheme reports.",
      features: {
        portfolio: {
          title: "Multi-member portfolio dashboard",
          desc: "Aggregate hundreds of parcels across all members with role-based access for managers and agronomists.",
        },
        benchmarking: {
          title: "Anonymous benchmarking",
          desc: "Compare member performance (yield, water use, NDVI) anonymously — drive best practices without exposing data.",
        },
        cap: {
          title: "CAP & eco-scheme reports",
          desc: "1-click PDF reports aligned with PAC/MAPA (RD 1054/2022) and EU eco-scheme requirements.",
        },
        advisory: {
          title: "Shared advisory tools",
          desc: "Cooperative agronomists can issue irrigation, fertilization and pest recommendations to any member parcel.",
        },
        alerts: {
          title: "Collective alerts",
          desc: "Frost, drought, fire and pest alerts dispatched to affected members via email and push.",
        },
        notebook: {
          title: "Digital field notebook",
          desc: "PAC-compliant traceability of treatments, irrigation and harvest events for every member.",
        },
      },
    },
    largeScale: {
      badge: "For Large-Scale Producers · 200+ ha",
      title: "Sub-parcel precision agriculture at enterprise scale",
      subtitle: "Full Sentinel-2 index suite, FAO-56 Dual Kc irrigation engine and K-Means++ zonification for VRI / VRA prescriptions. Designed for operations managing 200+ hectares.",
      cardTitle: "Large-scale Producers (200+ ha)",
      cardDesc: "Full Sentinel-2 suite, FAO-56 Dual Kc irrigation optimizer and sub-parcel zonification (VRI / VRA).",
      features: {
        indices: {
          title: "10+ vegetation indices",
          desc: "NDVI, NDWI, EVI, NDRE, SAVI, NDMI, GNDVI, chlorophyll and more — with phenological meta-index per crop stage.",
        },
        fao56: {
          title: "FAO-56 Dual Kc irrigation",
          desc: "Validated Penman-Monteith ET₀ (R²=0.878) with dual Kc water-balance for daily irrigation prescriptions.",
        },
        zonification: {
          title: "Sub-parcel zonification (K-Means++)",
          desc: "Automatic zoning with 100% polygon coverage. Export VRI / VRA prescriptions as Shapefile / GeoJSON.",
        },
        sar: {
          title: "Sentinel-1 SAR soil moisture",
          desc: "Real VV/VH backscatter from Sentinel-1 — works through clouds, no simulated fallback.",
        },
        yield: {
          title: "ML yield prediction",
          desc: "Crop-specific yield models calibrated with FAOSTAT and ESYRCE historical data.",
        },
        export: {
          title: "PDF reports + CSV / GeoJSON export",
          desc: "Editorial PDF reports plus raw data export for ERP and farm-management software.",
        },
      },
    },
    agribusiness: {
      badge: "For Agribusiness & Enterprise",
      title: "API-first integration for traders, suppliers and platforms",
      subtitle: "REST API, webhooks and ERP connectors to embed Sentinel Crop data inside your existing systems. Pilot programs available for traders, input suppliers and enterprise ag-platforms.",
      cardTitle: "Agribusiness & Enterprise",
      cardDesc: "API-first integration for traders, input suppliers and enterprise platforms — pilot programs available.",
      features: {
        api: {
          title: "Documented REST API",
          desc: "Parcel-level indices, weather, alerts and certifications via OpenAPI spec. Sandbox + production keys.",
        },
        webhooks: {
          title: "Generic webhooks",
          desc: "Push events (alerts, threshold breaches, certifications) to any HTTPS endpoint with HMAC signing.",
        },
        erp: {
          title: "ERP / claims connectors",
          desc: "Direct integration patterns for SAP, Microsoft Dynamics and major insurance claims platforms.",
        },
        sla: {
          title: "Uptime & response targets",
          desc: "Available for Enterprise pilots and custom implementation. Uptime and response-time targets defined contractually per customer.",
        },
        whitelabel: {
          title: "White-label option",
          desc: "Embed dashboards and reports under your own brand for downstream customers.",
        },
        pilots: {
          title: "Pilot programs",
          desc: "Structured 90-day pilots for traders, input suppliers and ag-platforms — with success metrics defined upfront.",
        },
      },
    },
  },
};